module.exports = __webpack_public_path__ + "static/img/kjdy19.f602503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy19.png
// module id = 334
// module chunks = 0